import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30d12d7d&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30d12d7d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d12d7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d12d7d')) {
      api.createRecord('30d12d7d', component.options)
    } else {
      api.reload('30d12d7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30d12d7d&scoped=true&lang=pug", function () {
      api.rerender('30d12d7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/vipRecords/performance/table/editableTextareaColumn/index.vue"
export default component.exports